'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { useQueryStates } from 'nuqs';
import { useCallback, useMemo } from 'react';
import { BasicSelect } from '@/modules/shared/components/basic-select/basic-select';
import { FilterDrawer } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { expensesMetricChartFiltersConfig } from '../../../lib/expenses-metric-chart-search-params';
import { GRANULARITY_OPTIONS } from '../../../types';
import { ExpensesMetricCumulativeDrawer, ExpensesMetricCumulativeFilter } from '../filter-metric-expenses-metric-chart/filter-cumulative-expenses-metric-chart';
import { ExpensesMetricGranularitySelectDrawer } from '../filter-metric-expenses-metric-chart/filter-granularity-expenses-metric-chart';
function FilterChart() {
  const $ = _c(49);
  const [filters, setFilters] = useQueryStates(expensesMetricChartFiltersConfig);
  const isCumulative = filters.cumulative === "true";
  let t0;
  if ($[0] !== setFilters) {
    t0 = () => {
      setFilters({
        granularity: GRANULARITY_OPTIONS.Monthly,
        cumulative: "false",
        cumulativeType: "relative"
      });
    };
    $[0] = setFilters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onReset = t0;
  const isResetDisabled = filters.granularity === GRANULARITY_OPTIONS.Monthly && filters.cumulative === "false" && filters.cumulativeType === "relative";
  let t1;
  if ($[2] !== isResetDisabled || $[3] !== onReset) {
    t1 = <Button variant="ghost" className="text-muted-foreground" onClick={onReset} disabled={isResetDisabled}>Reset Filters</Button>;
    $[2] = isResetDisabled;
    $[3] = onReset;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = `granularity-${filters.granularity}`;
  const t3 = filters.granularity;
  let t4;
  if ($[5] !== setFilters) {
    t4 = value => {
      setFilters({
        granularity: value as GRANULARITY_OPTIONS
      });
    };
    $[5] = setFilters;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = Object.values(GRANULARITY_OPTIONS);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== filters.granularity || $[9] !== t2 || $[10] !== t4) {
    t6 = <BasicSelect key={t2} label="Granularity" value={t3} onValueChange={t4} options={t5} placeholder="Monthly" />;
    $[8] = filters.granularity;
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== isCumulative || $[13] !== setFilters) {
    t7 = () => {
      setFilters({
        cumulative: isCumulative ? "false" : "true",
        cumulativeType: "relative"
      });
    };
    $[12] = isCumulative;
    $[13] = setFilters;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== setFilters) {
    t8 = value_0 => {
      setFilters({
        cumulative: "true",
        cumulativeType: value_0
      });
    };
    $[15] = setFilters;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== filters.cumulativeType || $[18] !== isCumulative || $[19] !== t7 || $[20] !== t8) {
    t9 = <ExpensesMetricCumulativeFilter isCumulative={isCumulative} cumulativeType={filters.cumulativeType} onToggleCumulative={t7} onChangeCumulativeType={t8} />;
    $[17] = filters.cumulativeType;
    $[18] = isCumulative;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t1 || $[23] !== t6 || $[24] !== t9) {
    t10 = <div className="hidden flex-wrap items-center justify-end gap-3 md:flex">{t1}{t6}{t9}</div>;
    $[22] = t1;
    $[23] = t6;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== setFilters) {
    t11 = async granularity => setFilters({
      granularity
    });
    $[26] = setFilters;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== filters.granularity || $[29] !== t11) {
    t12 = <ExpensesMetricGranularitySelectDrawer granularity={filters.granularity} setGranularity={t11} />;
    $[28] = filters.granularity;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== isCumulative || $[32] !== setFilters) {
    t13 = () => {
      setFilters({
        cumulative: isCumulative ? "false" : "true",
        cumulativeType: "relative"
      });
    };
    $[31] = isCumulative;
    $[32] = setFilters;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== setFilters) {
    t14 = value_1 => {
      setFilters({
        cumulative: "true",
        cumulativeType: value_1
      });
    };
    $[34] = setFilters;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== filters.cumulativeType || $[37] !== isCumulative || $[38] !== t13 || $[39] !== t14) {
    t15 = <ExpensesMetricCumulativeDrawer isCumulative={isCumulative} cumulativeType={filters.cumulativeType} onToggleCumulative={t13} onChangeCumulativeType={t14} />;
    $[36] = filters.cumulativeType;
    $[37] = isCumulative;
    $[38] = t13;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== isResetDisabled || $[42] !== onReset || $[43] !== t12 || $[44] !== t15) {
    t16 = <div className="flex items-center gap-4 md:hidden"><FilterDrawer onReset={onReset} isResetDisabled={isResetDisabled}>{t12}{t15}</FilterDrawer></div>;
    $[41] = isResetDisabled;
    $[42] = onReset;
    $[43] = t12;
    $[44] = t15;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t10 || $[47] !== t16) {
    t17 = <div className="row flex w-full items-center justify-end gap-4 md:w-auto">{t10}{t16}</div>;
    $[46] = t10;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
}
export { FilterChart };